// MOBILE MENU
import { lenis } from "../utilities/lenis";
import { isDesktop } from "../utilities/isDesktop";

document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.c-header');
  if(header && !isDesktop()){
    const headerNav = header.querySelector('.c-header-nav'),
          menuBtn = header.querySelector('.c-menu-btn'),
          menuBtnTop = menuBtn.querySelector('.top'),
          menuBtnBottom = menuBtn.querySelector('.bottom'),
          menuBtnCenter = menuBtn.querySelector('.center');

    gsap.set(headerNav, { display: 'flex', xPercent: 100 });

    // MENU SLIDEOUT TL
    let tlMenu = gsap.timeline({ 
      paused: true, 
      duration: 0.6, 
      ease: 'cubic-bezier(.165, .84, .44, 1)' 
    });
    tlMenu.to(headerNav, {
      xPercent: 0,
    }, 0);

    // MENU MORPH
    let tlMenuBtn = gsap.timeline({ 
      paused: true, 
      duration: 0.6, 
      ease: 'cubic-bezier(.165, .84, .44, 1)' 
    });
    tlMenuBtn.to(menuBtnCenter, { 
      autoAlpha: 0 
    }, 0)
    .to(menuBtnTop, { 
      rotation: 45,
      yPercent: -50,
      xPercent: -50,
      top: '50%',
      left: '50%',
    }, 0)
    .to(menuBtnBottom, { 
      rotation: -45, 
      yPercent: -50,
      xPercent: -50,
      top: '50%',
      left: '50%',
    }, 0);


    // MENU OPEN/CLOSE
    let menuOpen = false;
    menuBtn.addEventListener('click', function(e){
      e.preventDefault();
      header.classList.toggle('menu-open');

      if(menuOpen === false){
        openMenu();
      } else{
        closeMenu();
      }
    });
    function openMenu(){
      tlMenu.play();
      tlMenuBtn.play();
      lenis.stop();
      menuOpen = true;
    }
    function closeMenu(){
      tlMenu.reverse();
      tlMenuBtn.reverse();
      lenis.start();
      menuOpen = false;
    }


    // CLOSE ON CLICK OUTSIDE MENU
    document.addEventListener('click', function(e){
      if(menuOpen === true){
        if(!header.contains(e.target)){
          closeMenu();
        }
      }
    });
  }
});